<template>
  <v-container class="matchHeight">
    <v-card
      max-height="65vh"
      tile
      class="matchHeight"
      outlined
    >
      <v-list
        flat
        class="listContainer"
        max-height="60vh"
      >
        <v-list-group
          v-for="(program, programIndex) in multiSelectPrograms"
          :key="programIndex"
          value="true"
          prepend-icon="mdi-file-tree"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="program.name" />
            </v-list-item-content>
          </template>

          <v-list-group
            v-for="(project, projectIndex) in filteredProjects(program)"
            :key="projectIndex"
            value="true"
            sub-group
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="project.name" />
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(survey, surveyIndex) in filteredSurveys(project)"
              :key="surveyIndex"
            >
              <v-list-item-icon>
                <v-icon>mdi-clipboard-text</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="survey.name" />
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  @click="toggleList(survey)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list-group>
      </v-list>
    </v-card>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: "SurveyList",
  computed: {
    ...mapState({
      programs: state => state.programs.programs,
      projects: state => state.projects.projects,
      surveys: state => state.survey.surveys
    }),
    multiSelectPrograms() {
      return this.programs.filter(program => {
        const surveyList = this.surveys.filter(survey => {
          const programName = survey.survey_metadata.meta_data.dashboardFiltering.program
          return (programName === program.name) && survey.view_in_list
        })
        return program.view_multiple_surveys && (surveyList.length > 0)
      });
    }
  },
  methods: {
    ...mapActions("survey", ["updateSurvey"]),
    toggleList(survey) {
      let updatedSurvey = { pk: survey.pk, view_in_list: !survey.view_in_list };
      this.updateSurvey(updatedSurvey)
    },
    filteredProjects(program) {
      const projectPKList = this.surveys.map(survey => {
        if (survey.view_in_list) {
          return survey.project
        }
      })
      return this.projects.filter(project => {
        return (project.program === program.pk) && projectPKList.includes(project.pk)
      })
    },
    filteredSurveys(project) {
      return this.surveys.filter(survey => {
        return (survey.project === project.pk) && survey.view_in_list
      })
    }
  }
}
</script>